<template>
    <v-container>
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap justify-space-between> 
                <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
                <parliament-selector :value="selectedParliament" @input="selectedParliament = $event"></parliament-selector>
            </v-layout>
            <br/>
            <chart :chartData="chartData"/>
            <br/>
            <v-data-table 
                :headers="headers" 
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :hide-actions="true"
                :loading="loading"
                :custom-sort="customSort"
                :disable-initial-sort="true"
                >
                <template v-slot:items="props">
                    <!-- need to fix this -->
                    <td v-if="selectedParliament === 47" class="text-xs-left"><a @click="handleRecordClick(props.item.Range)">{{ props.item.Range.Name }}</a></td>
                    <td v-if="selectedParliament === 47" class="text-xs-left"><a @click="handleRecordClick(props.item.Range)">{{ props.item.Number }}</a></td>
                    <td v-if="selectedParliament !== 47" class="text-xs-left">{{ props.item.Range.Name }}</td>
                    <td v-if="selectedParliament !== 47" class="text-xs-left">{{ props.item.Number }}</td>
                    <td class="text-xs-left">{{ props.item.Percentage | percentage }}</td>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>
            
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import ParliamentSelector from './ParliamentSelector.vue';
import Chart from './Chart.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        Chart,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
        ParliamentSelector
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/Age?parliamentariantype=${parliamentarianType}&parliament=${this.selectedParliament}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        handleRecordClick(range) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule", "query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}
                ]
            };
            if (!range.Floor && !range.Ceiling) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"ageInDays","selectedOperator":"not stated","selectedOperand":"Age","value": 0 }});
            }
            if (range.Floor) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"ageInDays","selectedOperator":"greater than or equals","selectedOperand":"Age","value":range.Floor }});
            }
            if (range.Ceiling) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"ageInDays","selectedOperator":"less than or equal","selectedOperand":"Age","value":range.Ceiling}});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleParliamentarianType(query) {
            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (a.Range.Name ===  'Total') {
                    return 1;
                }
                if (index === "Range.Floor") {
                    // for items, get party
                    // a is less than b is -1
                    // a is greater than b is 1
                    if (a.Range.Name ===  'Not stated') {
                        return isDesc ? 1 : -1
                    }
                    if (b.Range.Name ===  'Not stated') {
                        return isDesc ? -1 : 1
                    }
                    const aRange = a.Range.Floor || 0;
                    const bRange = b.Range.Floor || 0;
                    if (!isDesc) {
                        return aRange < bRange ? -1 : 1;
                    } else {
                        return bRange < aRange ? -1 : 1;
                    }
                } else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => ({ Age: i.Range.Name, Number: i.Number, '%': this.$options.filters.percentage(i.Percentage) }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Age groups and distribution';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}. Age calculated as of ${(new Date()).toLocaleDateString()} or date of death`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        }
    },
    computed: {
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            chartData() {
                return {
                chart: {
                    type: 'column'
                },
                title: {
                    text: this.title
                },
                exporting: {
                    filename: 'Age groups and distribution'
                },
                xAxis: {
                    categories: this.items.filter(i => i.Range.Name !== 'Total').map(i => i.Range.Name)
                },
                yAxis: {
                    title: {
                        text: 'Number of Parliamentarians'
                    }
                },
                plotOptions: {
                    series: {
                        groupPadding: 0,
                        pointPadding: 0,
                        borderWidth: 0.1
                    }
                },
                series: [{
                    name: 'Number of Parliamentarians',
                    data: this.items.filter(i => i.Range.Name !== 'Total').map(i => i.Number)
                }]
            }
        }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        },
        selectedParliament: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
        title: 'Age groups and distribution',
        headers: [
            {
                text: 'Age',
                value: 'Range.Floor'
            },
            {
                text: 'Number',
                value: 'Number' 
            },
            {
                text: '%',
                value: 'Percentage'
            }
        ],
        selectedParliament: 47,
        items: [],
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        rowsPerPageItems: [ {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>